import React, { useState, useRef, useEffect } from "react";
import { getLogonInfoFromCookies } from "../utils/util";
import {
  VaporThemeProvider,
  Card,
  CardMedia,
  VaporUIShellNav,
  VaporAppBar,
  Box,
  Badge,
  Spinner,
  NotificationOverflow,
  AlertTitle,
  // Tabs,
  // Tab,
} from "@vapor/v3-components";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { useNavigate, useParams } from "react-router-dom";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { localFilter } from "./Home";
import { AuthResponse } from "../services/Models/AuthModel";
import { ToolbarButtons } from "../components/ToolbarButtons";
import { ShowFilter } from "../components/ShowFilter";
import { FilterListResponse } from "../services/Models/FilterListModel";
import { getFilterList } from "../services/filterListService";
import { CmsFilterDescriptorBase } from "../services/Models/FilterDescriptorModel";
import { useTranslation } from "react-i18next";
import { getSiteParameters } from "../services/siteParametersService";
import { useAuth } from "../Router/AuthProvider";
import { returnError } from "../utils/util";

const FilterDetail: React.FC = () => {
  const loginResult = useRef<AuthResponse>(getLogonInfoFromCookies());

  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const [showIconsOrList, setShowIconOrList] = useState<number>(
    localSiteParameters.current.Anteprima === "1" ? 1 : 0
  );
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [reloadFilterDetail, setReloadFilterDetail] = useState<number>(0);
  const { t } = useTranslation();
  const { id, idObject } = useParams();
  const navigate = useNavigate();
  const { performLogout } = useAuth();
  const [filters, setFilters] = useState<localFilter[]>(() => {
    const filterList = JSON.parse(
      localStorage.getItem("filterList") ?? "null"
    ) as localFilter[];
    if (filterList) {
      return filterList;
    } else return [];
  });
  const [currentFilter, setCurrentFilter] = useState<localFilter>(() => {
    let appFilter = filters.find((f: localFilter) => f.filterId === Number(id));
    if (!appFilter)
      appFilter = {
        filterId: 0,
        filterName: "",
        IconFile: "",
        TotPub: 0,
        LinkedDocs: false,
        noDownloadVideo: false,
      };
    if (idObject) {
      if (!isNaN(Number(idObject))) appFilter.idObject = Number(idObject);
    }
    return appFilter;
  });

  const onFilterSelected = (filterSelected: number) => {
    const appFilter = filters.find(
      (f: localFilter) => f.filterId === filterSelected
    );
    if (appFilter) setCurrentFilter(appFilter);
  };

  useEffect(() => {
    if (!loginResult.current)
      //navigate("/logout");
      performLogout();
  }, []);

  const returnHome = () => {
    navigate("/home");
  };

  const onClickIconsOrList = () => {
    setShowIconOrList(showIconsOrList === 1 ? 2 : 1);
  };

  const handleTabsChange = (event: React.SyntheticEvent, newValue: number) => {
    const appFilter = filters.find((f: localFilter) => f.filterId === newValue);
    if (appFilter) setCurrentFilter(appFilter);
  };

  const onReload = () => {
    if (localSiteParameters.current.Visualizzazione === "tabs")
      loadFilters(
        loginResult.current,
        localSiteParameters.current.ContPubFiltro,
        true
      );
    setReloadFilterDetail(reloadFilterDetail + 1);
  };

  const loadFilters = async (
    loginResult: AuthResponse,
    contPubFiltro: boolean,
    reload?: boolean
  ) => {
    setLoading(true);
    try {
      if (reload) {
        const resultSite: SiteParametersResponse = await getSiteParameters(
          null
        );
        if (resultSite && resultSite.ResultCode !== "ERROR") {
          localSiteParameters.current = resultSite;
          if (localSiteParameters.current.Visualizzazione === "continuo") {
            navigate("/presentationPage");
          }
        } else {
          setError("LoadSiteParameters : " + t("errore interno"));
          console.error("LoadSiteParameters Error :", "no result");
          setLoading(false);
          return;
        }
      }
      const result: FilterListResponse = await getFilterList(
        loginResult.SecurityToken,
        loginResult.Language ?? "it",
        contPubFiltro
      );
      if (result && result.ResultCode !== "ERROR") {
        console.log("getFilter successful:");
        const locFilters: localFilter[] = result.Filters.map(
          (filter: CmsFilterDescriptorBase) => {
            const appFilter: localFilter = {
              filterId: filter.FilterId,
              filterName: filter.FilterName,
              IconFile: filter.IconFile,
              TotPub: filter.TotPub,
              LinkedDocs: filter.LinkedDocs === "1" ? true : false,
              noDownloadVideo:
                filter.DownloadVideo === "nodownload" ? true : false,
            };
            return appFilter;
          }
        );

        localStorage.setItem("filterList", JSON.stringify(locFilters));
        setFilters(locFilters);
      } else {
        console.error("loadFilters Error :", t(returnError(result)));
      }
    } catch (error) {
      console.error("loadFilters Error :", error);
    } finally {
      setLoading(false);
    }
  };
  const filterPage = () => {
    return (
      <>
        {localSiteParameters.current.Visualizzazione === "tabs" ? (
          <>
            <Tabs
              onChange={handleTabsChange}
              value={currentFilter.filterId}
              variant="scrollable"
              sx={{
                minHeight: "36px", // Controlla l'altezza del contenitore tabs
                "& .MuiTab-root": {
                  color: "#0076AD",
                  textTransform: "none",
                  minHeight: "32px", // Altezza dei singoli tab
                  fontSize: "0.875rem", // Per un effetto "extraSmall"
                  padding: "6px 12px", // Padding ridotto per size piccola
                },
                "& .Mui-selected": {
                  backgroundColor: "#E3F2FD", // Sfondo del Tab selezionato
                  borderRadius: "4px", // Angoli arrotondati per il Tab selezionato
                },
              }}
            >
              {filters.map((filter) => (
                <Tab
                  label={filter.filterName}
                  value={filter.filterId}
                  iconPosition="start"
                  icon={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingRight: 0,
                        // p: 2,
                      }}
                    >
                      <img
                        src={
                          window.config.BASE_URL +
                          "/icon_archive/" +
                          filter.IconFile
                        }
                        alt="Home"
                        style={{ width: 32, height: 32 }}
                      />
                      <Badge
                        badgeContent={filter.TotPub}
                        max={9999}
                        size="medium"
                        sx={{
                          marginLeft: "-12px", // Sposta il badge a sinistra
                          marginTop: "-24px", // Sposta il badge in su
                          marginRight: "14px", // Sposta il badge in su
                        }}
                        variant="standard"
                        //          color="info"
                        color="counter"
                      />
                    </Box>
                  }
                />
              ))}
            </Tabs>
            <ShowFilter
              currentFilter={currentFilter}
              showIconsOrList={showIconsOrList}
              noTitle={true}
              subtractHeight={
                localSiteParameters.current.Visualizzazione === "tabs" ? 64 : 0
              }
              reloadFilterDetail={reloadFilterDetail}
            />
          </>
        ) : (
          <ShowFilter
            currentFilter={currentFilter}
            showIconsOrList={showIconsOrList}
            reloadFilterDetail={reloadFilterDetail}
          />
        )}
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
        {error && (
          <NotificationOverflow severity="error" onClose={() => setError(null)}>
            <AlertTitle>{t("error-header")}</AlertTitle>
            {error}
          </NotificationOverflow>
        )}
      </>
    );
  };
  return (
    <VaporThemeProvider>
      {localSiteParameters.current.Banner !== "0" ? (
        <VaporUIShellNav
          hideDrawer
          setDrawerOpen={() => {}}
          renderToolbar={
            <VaporAppBar
              disableDrawer
              leftContent={
                <Card>
                  <CardMedia
                    alt="image"
                    component="img"
                    image={window.config.BASE_URL + window.config.LOGO_CMS}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "45px",
                      objectFit: "contain",
                    }}
                  />
                </Card>
              }
              rightContent={
                <ToolbarButtons
                  showFilter={
                    localSiteParameters.current.Visualizzazione !== "tabs"
                      ? true
                      : false
                  }
                  showReload={true}
                  onMenuSelected={onFilterSelected}
                  showIconsOrList={showIconsOrList}
                  onClickIconsOrList={onClickIconsOrList}
                  onReloadFilters={onReload}
                />
              }
            />
          }
        >
          {filterPage()}
        </VaporUIShellNav>
      ) : (
        <>{filterPage()}</>
      )}
    </VaporThemeProvider>
  );
};

export default FilterDetail;
